import actionCreatorFactory from "typescript-fsa";
import { CustomerDetailRequestBody, CustomerDetailResponse } from "../../core/api/requests/customer/detail/types";
import { CustomerEditRequestBody, CustomerEditResponse } from "../../core/api/requests/customer/edit/types";
import { CustomerListRequestBody, CustomerListResponse } from "../../core/api/requests/customer/list/types";
import { CustomerRegisterRequestBody, CustomerRegisterResponse } from "../../core/api/requests/customer/register/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@Client");

export const clientActions = {
  fetchClients: actionCreator.async<CommonAsyncType<CustomerListResponse> & CustomerListRequestBody, CustomerListResponse>("FETCH_CLIENTS"),
  getClientDetails: actionCreator.async<CommonAsyncType<CustomerDetailResponse> & CustomerDetailRequestBody, CustomerDetailResponse>("GET_CLIENT_DETAILS"),
  registerNewClient: actionCreator.async<CommonAsyncType<CustomerRegisterResponse> & CustomerRegisterRequestBody, CustomerRegisterResponse>(
    "REGISTER_NEW_CLIENT",
  ),
  updateClient: actionCreator.async<CommonAsyncType<CustomerEditResponse> & CustomerEditRequestBody, CustomerEditResponse>("UPDATE_CLIENT"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
